import { createStore } from "redux";
import { combineReducers } from "redux";

import visibilityFilter from "./visibilityFilter/reducers";

export const store = createStore(combineReducers({ visibilityFilter }));
